import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/CSREnvironmentPage.css";

const ImageGallery = ({ images }) => {
  const [current, setCurrent] = useState(0);
  const nextSlide = () => setCurrent((prev) => (prev + 1) % images.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div className="gallery-container">
      <button className="gallery-nav prev" onClick={prevSlide}>
        ❮
      </button>
      <div className="gallery-slide">
        <img src={images[current]} alt={`gallery ${current + 1}`} />
      </div>
      <button className="gallery-nav next" onClick={nextSlide}>
        ❯
      </button>
    </div>
  );
};

const TabsSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (id) => {
    setActiveTab(id);
    setTimeout(() => {
      if (window.AOS) window.AOS.refresh();
    }, 50);
  };

  const tabs = [
    {
      id: 0,
      title: "Our Health & Education achievements",
      content: (
        <>
          <h4>
            <strong>
              Long-term ward renovation campaign of the Kalubowila Teaching
              Hospital
            </strong>
          </h4>
          <p>
            We renovated and maintained Ward No. 2 of the Kalubowila Teaching
            Hospital, a planned project that will continue for a period of four
            years. Our subcontractors have also been involved in this project by
            lending their expertise in painting, steel and civil work.
          </p>
          <p>
            The idea in getting the subcontractors involved and partnering up
            with us was to strengthen our relationships with them as well as an
            overall nurturing of a close bond between the subcontractor, the
            community and Colombo Dockyard.
          </p>
          <h4>
            <strong>Donations to hospitals</strong>
          </h4>
          <p>
            Colombo Dockyard renovated the children's ward of the
            Rathmalgaha-wewa Hospital, Horowpathana, Anuradhapura, at a cost in
            excess of Rs.450, 000.00
          </p>
          <p>
            The renovated ward was handed over to the hospital authorities,
            complete with ten beds with mattresses and a whole host of other
            items urgently needed at the hospital. In addition, the team also
            undertook to paint the entire ward.
          </p>
        </>
      ),
    },
    {
      id: 1,
      title: "Holistic development for the children",
      content: (
        <>
          <p>
            Colombo Dockyard donated to the 'Sadasarana Mathru Daraka
            Madyasthanaya' childcare centre, a fun day of activity, which
            included everything from meals for the day, gifts of school bags,
            stationery, miscellaneous toys and many other items needed by this
            childcare centre.
          </p>
          <p>
            In addition, equipment and stationery valued at over Rs. 250,000.00
            was donated to the students of 'Parana Govipala Viduhala' in
            Lahugala, Ampara, in Eastern Sri Lanka. The students who were helped
            face very difficult and trying times when attending their school.
          </p>
        </>
      ),
    },
    {
      id: 2,
      title: "Knowledge Development",
      content: (
        <>
          <h4>
            <strong>National Exhibitions</strong>
          </h4>
          <p>
            As an exports oriented Company, our products are not usually
            promoted or focused upon in the local market. Taking this factor
            into consideration, and with a wider requirement to disseminate
            knowledge to the community, Colombo Dockyard has participated in
            numerous national exhibitions, including the 'Boat Show 2010' and
            the Maritime Exhibition held by the Sri Lanka Navy.
          </p>
          <p>
            At the sixtieth year anniversary of the Sri Lanka Navy, we displayed
            our very own naval attack craft to the general public.
          </p>
          <h4>
            <strong>Knowledge Dissemination for Forces</strong>
          </h4>
          <p>
            Colombo Dockyard continues with practical and on the job training at
            our yard for the Marine Engineering Corps of the Sri Lankan forces.
          </p>
          <h4>
            <strong>
              Open Day for Employee Families and Retired Employees
            </strong>
          </h4>
          <p>
            Allowing employee families to visit the workplace of their loved
            ones creates a deep bonding and appreciation factor for the work
            performed by employees. On the open day, all facilities are made
            available to ensure that family members leave at the end of the day
            with pleasant memories and a good idea of just how Colombo Dockyard
            operates.
          </p>
          <p>
            Retired employees were hosted on the same day to make them feel
            appreciated for the yeoman services rendered.
          </p>
        </>
      ),
    },
    {
      id: 3,
      title: "Knowledge Centre",
      content: (
        <>
          <p>
            In addition to being an in house training centre, the Knowledge
            centre also serves as a learning centre for university students, and
            trainees alike. Most programs are conducted free of charge or only a
            nominal fee is applicable to cover the costs of personal protective
            equipment and meals.
          </p>
          <p>
            In addition, Colombo Dockyard continues an active educational
            partnership role with many universities and professional
            institutions for the development of entrepreneurial skills.
          </p>
        </>
      ),
    },
    {
      id: 4,
      title: "Personality Development",
      content: (
        <p>
          Colombo Dockyard has initiated a personality development and
          professional guidance program for children of employees within the
          ages of 18-25. Experts in career counseling, guidance and personality
          development take part in the training and at the last program,
          ninety-six participants were involved.
        </p>
      ),
    },
    {
      id: 5,
      title: "Primary Shelter",
      content: (
        <>
          <p>
            The Colombo Dockyard team has been involved in several different
            house constructions for employees and their families.
          </p>
          <p>
            Financial contributions and time for these activities have come from
            the Company and its employees.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="csr-tabs">
      <div className="tab-headers">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="csr-tab-content" key={activeTab}>
        {tabs[activeTab].content}
      </div>
    </div>
  );
};

const CSREnvironmentPage = () => {
  const tsunamiGallery1 = [
    "/wp-content/uploads/2016/02/146-1.jpg",
    "/wp-content/uploads/2016/02/146-2.jpg",
    "/wp-content/uploads/2016/02/146-3.jpg",
    "/wp-content/uploads/2016/02/146-4.jpg",
    "/wp-content/uploads/2016/02/146-5.jpg",
    "/wp-content/uploads/2016/02/146-6.jpg",
  ];
  const tsunamiGallery2 = [
    "/wp-content/uploads/2016/02/147-6.jpg",
    "/wp-content/uploads/2016/02/147-5.jpg",
    "/wp-content/uploads/2016/02/147-4.jpg",
    "/wp-content/uploads/2016/02/147-3.jpg",
    "/wp-content/uploads/2016/02/147-2.jpg",
    "/wp-content/uploads/2016/02/147-1.jpg",
  ];

  return (
    <>
      <Header />

      <section
        className="csr-banner"
        style={{
          backgroundImage: "url('/wp-content/uploads/2016/02/145.jpg')",
        }}
      ></section>

      <div className="csr-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>CSR Environment</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            CSR Environment
          </h1>

          <div className="csr-row">
            <div className="csr-col" data-aos="fade-right">
              <img
                src="/wp-content/uploads/2016/02/144.jpg"
                alt="Monaragala Buddha Statue"
              />
              <h3>
                <strong>
                  Monaragala Buddha Statue at Rambadagalla, Kurunegala
                </strong>
              </h3>
              <p>
                Our CSR initiatives extend beyond mere philanthropy. All our
                projects remain close to our heart, uniting the entire
                organisation with a single minded passion. We believe that
                fostering team spirit within the organisation is the first step
                to engendering broader social development in the country that
                would eventually lead to a sustainable future. Hence all CSR
                projects that we undertake are personally overseen by our
                employees.
              </p>
            </div>
            <div className="csr-col" data-aos="fade-left">
              <img
                src="/wp-content/uploads/2016/02/145.jpg"
                alt="Abayagiriya Dagabo"
              />
              <h3>
                <strong>Abayagiriya Dagabo</strong>
              </h3>
              <p>
                The Abhayagiriya restoration project and the renovation of the
                Monaragala Buddha Statue at Rambadagalla, Kurunegala (the
                largest sitting Buddha Statue out of Granite rock stone) depicts
                the collective effort of our employees and the engineering
                contribution to our national heritage.
              </p>
            </div>
          </div>

          <h3 className="section-heading" data-aos="fade-right">
            Tsunami Disaster
          </h3>

          <div className="csr-row">
            <div className="csr-col" data-aos="fade-right">
              <ImageGallery images={tsunamiGallery1} />
            </div>
            <div className="csr-col" data-aos="fade-left">
              <p>
                The 2004 Boxing Day Tsunami was undoubtedly one of the most
                harrowing experiences the country has witnessed in recent times.
                The inescapable damage devastated the nation. Everyone was
                affected in some way or the other and Colombo Dockyard was no
                exception. The rising water levels caused by the Tsunami
                resulted in a massive overflow of sea water that continued to
                spill over the dock gate. Colombo Dockyard staff spurred into
                action. Undeterred by the unfolding disaster, they reacted
                swiftly to stem the flow of water, thereby mitigating the
                material damage to the vessels that were docked for repair, at
                the time.
              </p>
            </div>
          </div>

          <div className="csr-row">
            <div className="csr-col" data-aos="fade-right">
              <p>
                Following the disaster, Colombo Dockyard was mandated with the
                task of resurrecting the Beruwela harbour. The harbour and the
                surrounding area had suffered countless damage, leaving
                communities distraught and destitute. We hit the ground running,
                deploying multiple search and rescue teams that salvaged
                countless fishing vessels. Within 48 hours, Colombo Dockyard was
                successful in returning the Beruwela Habour to some semblance of
                normalcy. Appreciating the urgency of the situation, every
                single staff member threw themselves into the rescue effort with
                a passionate fervor. To support the affected communities, we
                also contributed in managing the Ethanamadala Tsunami Camp in
                the Kalutara District and built permanent homes for the
                displaced.
              </p>
            </div>
            <div className="csr-col" data-aos="fade-left">
              <ImageGallery images={tsunamiGallery2} />
            </div>
          </div>

          <div className="csr-row">
            <div className="csr-col" data-aos="fade-right">
              <img
                src="/wp-content/uploads/2016/02/csr-1.jpg"
                alt="Community support"
              />
            </div>
            <div className="csr-col" data-aos="fade-left">
              <p>
                Colombo Dockyard understands the importance of sustaining
                community based development activity and makes every effort to
                contribute all possible resources to attain these objectives.
              </p>
              <p>
                We strongly believe that sustainable measures must be instilled
                into wider spheres of our community so that it permeates and
                results in better economic prosperity for all.
              </p>
              <p>
                Our sustainable development platforms revolve around better
                health and education, knowledge development and primary shelter.
              </p>
            </div>
          </div>

          <TabsSection />
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default CSREnvironmentPage;
